import React, { Component } from 'react';
import { connect } from "react-redux";
import './style/common.scss';
import "./style/base.scss";
import { 
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { 
  Nav,
  Footer,
  VerifyResult, 
  ResultDetail,
  resultHistory,
  Home,
  FillingMoney,
} from "./pages";
import { Loading } from "./components";
import { getPointSum, getVipTime2 } from "./models";
class App extends Component {
  render() {
    return (
      <div className="App">
        <Loading></Loading>
        <Router>
          <Nav />
          <Switch>
            <Redirect exact from="/" to="/home"></Redirect>
            {/* <Route path="/start">
              <Switch>
                <Redirect exact from="/start" to="/start/home"></Redirect>
                <Route path="/start/home" component={Home}></Route>
                <Route path="/start/verifyResult/:batchId" component={VerifyResult}></Route>
              </Switch>
            </Route> */}
            <Route path="/home" component={Home}></Route>
            <Route path="/verifyResult/:batchId" component={VerifyResult}></Route>
            <Route path="/resultDetail" component={ResultDetail}></Route>
            <Route path="/resultHistory" component={resultHistory}></Route>
            <Route path="/fillingMoney" component={FillingMoney}></Route>
          </Switch>
          <Footer></Footer>
        </Router>
      </div>
    );
  }
  componentDidMount(){
		const { setVerifyresult } = this.props;
		Promise.all([ getPointSum(), getVipTime2() ]).then((resultArr)=>{
      let pointSum = resultArr[0];
      let vipInfo = resultArr[1];
      setVerifyresult({pointSum,vipInfo});
    }).catch(()=>{})
	}
}

const mapState = (store)=>{
  return {
  }
}
const mapDispatch = (dispatch)=>{
  return {
		setVerifyresult(data){
      dispatch({
        type: "setVerifyresult",
        data,
      })
    },
  }
}
export default connect(mapState,mapDispatch)(App);
